module.exports = __webpack_public_path__ + "img/slim.517605a6.png";